import { createContext } from "react";

interface PermissionsContextType {
  permissions?: string[];
  isLoading: boolean;
  error: Error | null;

  // Will refetch permission permissions and rerender permissioned layout.
  refetch: () => void;
}

export const PermissionsContext = createContext<PermissionsContextType | undefined>(undefined);
